import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "list-page-table-panel list-page-table-panel--fill"
};
const _hoisted_2 = {
  class: "data-table-shell"
};
const _hoisted_3 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_4 = {
  class: "data-table min-w-[960px]"
};
const _hoisted_5 = {
  class: "data-table-head"
};
const _hoisted_6 = {
  class: "data-table-th text-left w-12"
};
const _hoisted_7 = ["checked"];
const _hoisted_8 = {
  class: "data-table-body"
};
const _hoisted_9 = {
  class: "data-table-td is-center"
};
const _hoisted_10 = ["checked", "onChange"];
const _hoisted_11 = {
  class: "data-table-td text-sm text-slate-900"
};
const _hoisted_12 = {
  class: "data-table-td text-sm text-slate-900 font-medium"
};
const _hoisted_13 = {
  class: "data-table-td text-sm text-slate-500"
};
const _hoisted_14 = {
  class: "data-table-td text-sm text-slate-500"
};
const _hoisted_15 = {
  class: "data-table-td text-sm text-slate-900"
};
const _hoisted_16 = {
  class: "data-table-td"
};
const _hoisted_17 = {
  class: "data-table-td text-sm text-slate-500"
};
const _hoisted_18 = {
  class: "data-table-td data-table-sticky-right data-table-sticky-action"
};
const _hoisted_19 = {
  class: "flex items-center gap-1"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_23 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_24 = {
  class: "p-6 space-y-4"
};
import { ref, reactive, computed, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { getPosts, createPost, updatePost, deletePost } from '@/api/post';
import AppPagination from '@/components/AppPagination.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import AppModal from '@/components/AppModal.vue';

// 搜索条件

export default {
  __name: 'PostManagement',
  setup(__props) {
    const searchCode = ref('');
    const searchName = ref('');
    const searchStatus = ref('');

    // 选中项
    const selectedIds = ref([]);

    // 模态框状态
    const showModal = ref(false);
    const showDeleteModal = ref(false);
    const isEdit = ref(false);
    const pendingDelete = ref(null);

    // 岗位数据
    const loading = ref(false);
    const posts = ref([]);
    const total = ref(0);
    const page = ref(1);
    const size = ref(10);
    const totalPages = computed(() => {
      if (!total.value || !size.value) return 1;
      return Math.max(1, Math.ceil(total.value / size.value));
    });

    // 表单数据
    const form = reactive({
      id: '',
      code: '',
      name: '',
      alias: '',
      postLevel: '',
      sort: 1,
      status: true,
      remark: ''
    });

    // 过滤后的岗位列表
    const filteredPosts = computed(() => posts.value);
    async function fetchPosts(pageOverride) {
      if (pageOverride) {
        page.value = pageOverride;
      }
      loading.value = true;
      try {
        const params = {
          code: searchCode.value || undefined,
          name: searchName.value || undefined,
          status: searchStatus.value === '' ? undefined : searchStatus.value,
          page: page.value,
          size: size.value
        };
        const data = await getPosts(params);
        const records = Array.isArray(data?.records) ? data.records : [];
        posts.value = records;
        total.value = Number(data?.total || records.length || 0);
        selectedIds.value = [];
      } catch (error) {
        console.error('加载岗位列表失败:', error);
        ElMessage.error(error.message || '加载岗位列表失败');
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      fetchPosts(1);
    }

    // 重置搜索
    function resetSearch() {
      searchCode.value = '';
      searchName.value = '';
      searchStatus.value = '';
      fetchPosts(1);
    }

    // 全选/取消全选
    function toggleSelectAll(e) {
      if (e.target.checked) {
        selectedIds.value = filteredPosts.value.map(p => p.id);
      } else {
        selectedIds.value = [];
      }
    }

    // 选择/取消选择
    function toggleSelect(id) {
      const index = selectedIds.value.indexOf(id);
      if (index > -1) {
        selectedIds.value.splice(index, 1);
      } else {
        selectedIds.value.push(id);
      }
    }

    // 打开新增模态框
    function openAddModal() {
      isEdit.value = false;
      form.id = '';
      form.code = '';
      form.name = '';
      form.alias = '';
      form.postLevel = '';
      form.sort = 1;
      form.status = true;
      form.remark = '';
      showModal.value = true;
    }

    // 打开编辑模态框
    function openEditModal(post) {
      isEdit.value = true;
      form.id = post.id;
      form.code = post.code;
      form.name = post.name;
      form.alias = post.alias || '';
      form.postLevel = post.postLevel || '';
      form.sort = post.sort;
      form.status = post.status ?? true;
      form.remark = post.remark || '';
      showModal.value = true;
    }

    // 关闭模态框
    function closeModal() {
      showModal.value = false;
    }

    // 保存岗位
    async function savePost() {
      if (!form.code.trim()) {
        ElMessage.warning('请输入岗位编码');
        return;
      }
      if (!form.name.trim()) {
        ElMessage.warning('请输入岗位名称');
        return;
      }
      const payload = {
        id: form.id,
        name: form.name,
        code: form.code,
        alias: form.alias,
        postLevel: form.postLevel,
        sort: form.sort,
        status: form.status,
        remark: form.remark
      };
      try {
        if (isEdit.value) {
          await updatePost(form.id, payload);
          ElMessage.success('修改成功');
        } else {
          await createPost(payload);
          ElMessage.success('新增成功');
        }
        await fetchPosts(page.value);
        closeModal();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    }

    // 删除岗位
    function handleDelete(post) {
      pendingDelete.value = post;
      showDeleteModal.value = true;
    }

    // 确认删除
    async function confirmDelete() {
      if (pendingDelete.value) {
        try {
          await deletePost(pendingDelete.value.id);
          ElMessage.success('删除成功');
          await fetchPosts(page.value);
        } catch (error) {
          ElMessage.error(error.message || '删除失败');
        }
      }
      closeDeleteModal();
    }

    // 关闭删除确认弹窗
    function closeDeleteModal() {
      showDeleteModal.value = false;
      pendingDelete.value = null;
    }
    function handlePageChange(p) {
      page.value = p;
      fetchPosts(p);
    }
    function handlePageSizeChange(s) {
      size.value = s;
      page.value = 1;
      fetchPosts(1);
    }
    onMounted(() => {
      fetchPosts();
    });
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "岗位管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "统一维护岗位编码、名称、职级与状态")])])], -1)]))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": "",
          "refresh-loading": loading.value,
          onRefresh: _cache[3] || (_cache[3] = $event => fetchPosts(page.value))
        }, {
          searchActionsLeading: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: openAddModal,
            class: "btn-primary"
          }, [...(_cache[12] || (_cache[12] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 4v16m8-8H4"
          })], -1), _createTextVNode(" 新增 ", -1)]))])), [[_directive_permission, 'org:post:add']])]),
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            onClick: handleSearch,
            class: "btn-primary"
          }, " 搜索 "), _createElementVNode("button", {
            type: "button",
            onClick: resetSearch,
            class: "btn-secondary"
          }, " 重置 ")]),
          default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchCode.value = $event),
            type: "text",
            placeholder: "岗位编码",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, searchCode.value]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchName.value = $event),
            type: "text",
            placeholder: "岗位名称",
            class: "form-input form-control-sm filter-bar-field"
          }, null, 512), [[_vModelText, searchName.value]]), _createVNode(_component_el_select, {
            modelValue: searchStatus.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchStatus.value = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "正常",
              value: true
            }), _createVNode(_component_el_option, {
              label: "停用",
              value: false
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_createElementVNode("thead", _hoisted_5, [_createElementVNode("tr", null, [_createElementVNode("th", _hoisted_6, [_createElementVNode("input", {
          type: "checkbox",
          checked: selectedIds.value.length === filteredPosts.value.length && filteredPosts.value.length > 0,
          onChange: toggleSelectAll,
          class: "form-check"
        }, null, 40, _hoisted_7)]), _cache[13] || (_cache[13] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "岗位编码", -1)), _cache[14] || (_cache[14] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "岗位名称", -1)), _cache[15] || (_cache[15] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "别名简称", -1)), _cache[16] || (_cache[16] = _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "职级", -1)), _cache[17] || (_cache[17] = _createElementVNode("th", {
          class: "data-table-th text-left w-20"
        }, "排序", -1)), _cache[18] || (_cache[18] = _createElementVNode("th", {
          class: "data-table-th text-left w-24"
        }, "状态", -1)), _cache[19] || (_cache[19] = _createElementVNode("th", {
          class: "data-table-th text-left w-32"
        }, "创建时间", -1)), _cache[20] || (_cache[20] = _createElementVNode("th", {
          class: "data-table-th text-left data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作", -1))])]), _createElementVNode("tbody", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPosts.value, post => {
          return _openBlock(), _createElementBlock("tr", {
            key: post.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_9, [_createElementVNode("input", {
            type: "checkbox",
            checked: selectedIds.value.includes(post.id),
            onChange: $event => toggleSelect(post.id),
            class: "form-check"
          }, null, 40, _hoisted_10)]), _createElementVNode("td", _hoisted_11, _toDisplayString(post.code), 1), _createElementVNode("td", _hoisted_12, _toDisplayString(post.name), 1), _createElementVNode("td", _hoisted_13, _toDisplayString(post.alias || '-'), 1), _createElementVNode("td", _hoisted_14, _toDisplayString(post.postLevel || '-'), 1), _createElementVNode("td", _hoisted_15, _toDisplayString(post.sort), 1), _createElementVNode("td", _hoisted_16, [_createElementVNode("span", {
            class: _normalizeClass(["status-badge", post.status ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'])
          }, [_cache[21] || (_cache[21] = _createElementVNode("span", {
            class: "w-1.5 h-1.5 bg-current rounded-full mr-1"
          }, null, -1)), _createTextVNode(" " + _toDisplayString(post.status ? '正常' : '停用'), 1)], 2)]), _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.$formatDateTime(post.createTime)), 1), _createElementVNode("td", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => openEditModal(post),
            class: "table-action-button is-primary",
            title: "修改",
            "aria-label": "修改"
          }, [...(_cache[22] || (_cache[22] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
          })], -1)]))], 8, _hoisted_20)), [[_directive_permission, 'org:post:edit']]), _withDirectives((_openBlock(), _createElementBlock("button", {
            onClick: $event => handleDelete(post),
            class: "table-action-button is-danger",
            title: "删除",
            "aria-label": "删除"
          }, [...(_cache[23] || (_cache[23] = [_createElementVNode("svg", {
            class: "w-4 h-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
          })], -1)]))], 8, _hoisted_21)), [[_directive_permission, 'org:post:remove']])])])]);
        }), 128))])])])]), total.value > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          current: page.value,
          size: size.value,
          total: total.value,
          pages: totalPages.value,
          "page-sizes": [10, 20, 50],
          onPageChange: handlePageChange,
          onSizeChange: handlePageSizeChange
        }, null, 8, ["current", "size", "total", "pages"])) : _createCommentVNode("", true)]), _createVNode(AppModal, {
          visible: showDeleteModal.value,
          size: "sm",
          "panel-class": "mx-4",
          onClose: closeDeleteModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "p-6 text-center"
          }, [_cache[24] || (_cache[24] = _createElementVNode("div", {
            class: "w-12 h-12 mx-auto mb-4 text-red-500"
          }, [_createElementVNode("svg", {
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          })])], -1)), _cache[25] || (_cache[25] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900 mb-2"
          }, "确定要删除吗？", -1)), _cache[26] || (_cache[26] = _createElementVNode("p", {
            class: "text-sm text-slate-500 mb-6"
          }, "删除后无法恢复，请确认是否删除。", -1)), _createElementVNode("div", {
            class: "flex items-center justify-center gap-3"
          }, [_createElementVNode("button", {
            onClick: closeDeleteModal,
            class: "btn-secondary"
          }, " 取消 "), _createElementVNode("button", {
            onClick: confirmDelete,
            class: "btn-danger-secondary"
          }, " 确定删除 ")])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showModal.value,
          size: "lg",
          "panel-class": "mx-4",
          onClose: closeModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createElementVNode("h3", _hoisted_23, _toDisplayString(isEdit.value ? '修改岗位' : '新增岗位'), 1), _createElementVNode("button", {
            onClick: closeModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
          }, [...(_cache[27] || (_cache[27] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", null, [_cache[28] || (_cache[28] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("岗位编码 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.code = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入岗位编码"
          }, null, 512), [[_vModelText, form.code]])]), _createElementVNode("div", null, [_cache[29] || (_cache[29] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("岗位名称 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.name = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入岗位名称"
          }, null, 512), [[_vModelText, form.name]])]), _createElementVNode("div", null, [_cache[30] || (_cache[30] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "岗位别名简称", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.alias = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入岗位别名简称"
          }, null, 512), [[_vModelText, form.alias]])]), _createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "岗位职级", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.postLevel = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "如：M1、P2、初级、高级"
          }, null, 512), [[_vModelText, form.postLevel]])]), _createElementVNode("div", null, [_cache[32] || (_cache[32] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("岗位排序 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.sort = $event),
            type: "number",
            class: "form-input w-full",
            placeholder: "数字越大越靠后"
          }, null, 512), [[_vModelText, form.sort, void 0, {
            number: true
          }]])]), _createElementVNode("div", null, [_cache[33] || (_cache[33] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "岗位状态", -1)), _createVNode(_component_el_select, {
            modelValue: form.status,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.status = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "正常",
              value: true
            }), _createVNode(_component_el_option, {
              label: "停用",
              value: false
            })]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[34] || (_cache[34] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "备注", -1)), _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.remark = $event),
            rows: "3",
            class: "form-textarea",
            placeholder: "请输入备注信息"
          }, null, 512), [[_vModelText, form.remark]])])]), _createElementVNode("div", {
            class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl"
          }, [_createElementVNode("button", {
            onClick: closeModal,
            class: "btn-secondary"
          }, " 取消 "), _createElementVNode("button", {
            onClick: savePost,
            class: "btn-primary"
          }, " 确定 ")])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};